import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import ShapePopupOne from './ShapePopupOne';
import ShapePopupTwo from './ShapePopupTwo';
import ShapePopupThree from './ShapePopupThree';
import { getWorkWindowConfig } from "../../../actions/geo";
import { usePermission } from '../../../helpers/common';
import "../../../../assets/scss/shape-popup.scss";
import ShapePopupFour from './ShapePopupFour';

const ShapePopup = ({ isRequesting, farmConfiguration, actions, ...rest }) => {
    const { farmId, editable, typeId } = rest.shape;
    const { selectedPlanType: selectedPlanTypeId } = useSelector((state => state.plan));
    const { searchParams } = useSelector(state => state.analyze);
    const allow = usePermission();
    const isAllowEdit = allow("geo-shape-config", "edit");
    const shapeProps = {
        ...rest,
        shape: {
            ...rest.shape,
            geoShapeId: rest.shape.id,
            geoShapeRefId: rest.shape.shapeRefId
        },
        selectedPlanTypeId,
        searchParams,
        farmId
    };

    useEffect(() => {
        if (!isAllowEdit) return;
        if (!isRequesting && !farmConfiguration)
            actions.getWorkWindowConfig(farmId);
    }, []);

    if (shapeProps.shape && shapeProps.shape.geoJSON && shapeProps.shape.geoJSON.type === "marker")
        return <ShapePopupFour {...shapeProps} />
    if (!editable && typeId === 2)
        return !isRequesting && (farmConfiguration || !isAllowEdit) ?
            (isAllowEdit ? <ShapePopupThree {...shapeProps} /> : <ShapePopupTwo {...shapeProps} />) :
            <div>Fetching configuration...</div>;
    return <ShapePopupOne {...shapeProps} />;
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getWorkWindowConfig }, dispatch)
});

const mapStateToProps = (state, ownProps) => {
    const wwConfig = state.geo.workWindowConfigById[ownProps.shape.farmId];
    return {
        isRequesting: wwConfig ? wwConfig.isRequesting : false,
        farmConfiguration: wwConfig && wwConfig.configuration ? wwConfig.configuration : null
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShapePopup);